<div class="custom-scroll-bar" class="table-wraper rounded-lg overflow-x-auto">
  <table id="table" class="border-collapse w-full">
    <tr>
      <th class="repeat-index-number">#</th>
      <th
        *ngFor="let f of field.fieldArray.fieldGroup"
        [ngClass]="{hide: onHide()}"
        [ngStyle]="resizeColumn(f?.templateOptions?.width)"
      >
        {{f?.templateOptions?.columnName || f?.templateOptions?.label}}
        {{f?.templateOptions?.required ? '*' : ''}}
      </th>
    </tr>
    <tr *ngFor="let fg of field.fieldGroup; let i = index">
      <td class="repeat-index-number index-row">{{i + 1}}</td>
      <td
        *ngFor="let f of fg.fieldGroup"
        [ngStyle]="resizeColumn(f?.templateOptions?.width)"
        [ngClass]="{hide: onHide()}"
      >
        <formly-field [field]="f"></formly-field>
      </td>
    </tr>
  </table>
</div>
<button class="action-btn add" [disabled]="!isValid" (click)="onAdd()">
  <img src="assets/icons/plus.svg" alt="add" />
</button>
<button class="action-btn" [disabled]="!fieldHasMultiple" (click)="onRemove()">
  <img src="assets/icons/trash-black.svg" alt="remove" />
</button>
